// src/components/PaymentPage.jsx
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/SlotBooking-css/PaymentPage.css";

export default function PaymentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { cartItems = [], totalToPay = 0 } = location.state || {};

  const [paymentMethod, setPaymentMethod] = useState("upi");

  const handlePayNow = () => {
    alert("Payment Successful!");
    navigate("/");
  };

  return (
    <div className="payment-page-container">
      <h2>Complete Your Payment</h2>

      <div className="payment-content">
        {/* LEFT: Payment Options */}
        <div className="payment-methods">
          <h3>Select Payment Method</h3>
          <ul className="method-list">
            <li onClick={() => setPaymentMethod("upi")} className={paymentMethod === "upi" ? "active" : ""}>UPI</li>
            <li onClick={() => setPaymentMethod("card")} className={paymentMethod === "card" ? "active" : ""}>Credit/Debit Card</li>
            <li onClick={() => setPaymentMethod("netbanking")} className={paymentMethod === "netbanking" ? "active" : ""}>Net Banking</li>
            <li onClick={() => setPaymentMethod("wallet")} className={paymentMethod === "wallet" ? "active" : ""}>Wallet</li>
          </ul>

          <div className="payment-form">
            {paymentMethod === "upi" && (
              <div>
                <label>Enter UPI ID</label>
                <input type="text" placeholder="example@upi" />
              </div>
            )}

            {paymentMethod === "card" && (
              <div>
                <label>Card Number</label>
                <input type="text" placeholder="xxxx-xxxx-xxxx-xxxx" />
                <div className="card-row">
                  <input type="text" placeholder="MM/YY" />
                  <input type="text" placeholder="CVV" />
                </div>
                <input type="text" placeholder="Name on Card" />
              </div>
            )}

            {paymentMethod === "netbanking" && (
              <div>
                <label>Select Bank</label>
                <select>
                  <option>HDFC</option>
                  <option>ICICI</option>
                  <option>SBI</option>
                  <option>Axis Bank</option>
                </select>
              </div>
            )}

            {paymentMethod === "wallet" && (
              <div>
                <label>Select Wallet</label>
                <select>
                  <option>Paytm</option>
                  <option>PhonePe</option>
                  <option>Amazon Pay</option>
                </select>
              </div>
            )}
          </div>
        </div>

        {/* RIGHT: Summary */}
        <div className="payment-summary-box">
          <h3>Order Summary</h3>
          {cartItems.map((item) => (
            <div key={item.id} className="payment-item">
              <span>{item.title}</span>
              <span>₹{item.price}</span>
            </div>
          ))}

          <hr />
          <div className="payment-total">
            <strong>Total:</strong>
            <strong>₹{totalToPay}</strong>
          </div>

          <button className="pay-now-btn" onClick={handlePayNow}>
            Pay Now
          </button>
        </div>
      </div>
    </div>
  );
}
